"use client";
import "./chunk-M66XENHI.js";
import ParaCore from "@getpara/core-sdk";
import { WebUtils } from "./WebUtils.js";
class Para extends ParaCore {
  constructor(env, apiKey, opts) {
    super(env, apiKey, opts);
  }
  getPlatformUtils() {
    return new WebUtils();
  }
}
export {
  Para
};
